import type { Category, DefaultResponseBody, ListResponseBody } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreCategoriesApi(client: ApiClient) {
  return {
    list: (params: { parentId?: number; type?: string } = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Category>>("/categories", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    detail: (id: number, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<Category>>(`/categories/${id}`, { signal })
        .then((res) => res.data as Category),
  };
}
